export default "__VITE_ASSET__ChONhH6c__"